export const InputProductType = {
  /** Nassfutter */
  WetFood: 'wet_food',
  /** Trockenfutter */
  DryFood: 'dry_food',
  /** Frische-Menüs / barf */
  Barf: 'barf',
  /** Snacks */
  Snacks: 'snacks',
  /** Nahrungsergänzung */
  FoodSupplement: 'food_supplement',
  /** Zubehör */
  Accessories: 'accessories',
  /** Geschenk */
  Gift: 'gift',
  /** Pflege */
  Care: 'care_product',
  /** Testpaket */
  TestPackage: 'test_package',
  /** Med */
  Med: 'med',
} as const;

export const WetFoodTagValues = {
  Sauce: 'sauce', // Tags: saucen-menu or juicyfilets
  Pate: 'pate', // Tags: puremeat or filet-menu or meatypate
  Cream: 'cream', // Tags: silkycream
} as const;

export type InputProductType = (typeof InputProductType)[keyof typeof InputProductType];

export type WetFoodTagValues = (typeof WetFoodTagValues)[keyof typeof WetFoodTagValues];

const foodTypeSet = new Set([Object.values(InputProductType)].flat());

/**
 * Assert function for NutritionSegmentationIds
 */
export function isFoodType(input: any): input is InputProductType {
  return foodTypeSet.has(input as unknown as any);
}

const wetFoodTypeSet = new Set([Object.values(WetFoodTagValues)].flat());

/**
 * Assert function for WetFoodType
 */
export function isWetFoodType(input: any): input is WetFoodTagValues {
  return wetFoodTypeSet.has(input as unknown as any);
}
